import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TooltippedText',
  props: {
    text: null,
    maxWidth: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  text?: string;
  maxWidth?: number | string;
};



const show = ref(false);
const textRef = ref();

const maxWidthValue = computed(() => props.maxWidth ? ((typeof props.maxWidth === 'number') ? props.maxWidth + 'px' : props.maxWidth) : undefined);

onMounted(
  async () => {
    await nextTick(() => {
      checkRange();
    })
  }
)

function checkRange() {
  const el = textRef.value;
  if (el) {
    const range = new Range();
    range.selectNodeContents(el);

    const rangeRect = range.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    // add .5px bcz when the range width shoud be exactly the same as that of the rect,
    // it is slightly smaller, so the tooltip is shown where not yet needed
    show.value = rangeRect.width > (elRect.width + .5);
  }
}

function mouseover() {
  checkRange();
}

expose({ show });

return { __sfc: true,props, show, textRef, maxWidthValue, checkRange, mouseover }
}

})